<template>
  <div class="mortgage-report-help">
    <div class="overlay-backdrop" @click="$emit('close')" />
    <div class="overlay-sheet">
      <button
        type="button"
        class="sheet-close"
        aria-label="close"
        @click="$emit('close')"
      >
        <img :src="icons.close" alt="" />
      </button>

      <div class="sheet-content">
        <h1 class="sheet-heading" dir="auto">
          איפה מוצאים את דו״ח<br />היתרות של המשכנתא?
        </h1>

        <p class="sheet-body" dir="auto">
          דו"ח יתרות הוא מסמך רשמי מהבנק שמציג את מצב ההלוואה שלך: כמה נותר לשלם, באילו מסלולים, ומה גובה ההחזר החודשי.
        </p>

        <p class="sheet-body" dir="auto">
          כדי להוריד אותו, אפשר להכנס <strong>לאזור האישי באתר או באפליקציה</strong>
          של הבנק שבו לקחת את המשכנתא.
          בתפריט המשכנתאות אמור להופיע סעיף בשם "דו"ח יתרות",
          "דו"ח סילוקין" או "מצב חשבון משכנתא".
        </p>

        <div class="tip-callout" dir="rtl">
          <img class="tip-icon" :src="icons.seedling" alt="" />
          <p class="tip-text">
            אם לא מצאת – כדאי לפנות לנציג הבנק ובקש לקבל את הדו"ח במייל.
          </p>
        </div>
      </div>

      <div class="sheet-cta-area">
        <CtaButton text="הבנתי, תודה" @click="$emit('close')" />
      </div>
    </div>
  </div>
</template>

<script>
import CtaButton from './CtaButton.vue';

/* eslint-disable global-require */
const icons = {
  close: require('../assets/lucide-x.svg'),
  seedling: require('../assets/seedling-green.svg'),
};
/* eslint-enable global-require */

export default {
  name: 'MortgageReportHelpSheet',
  components: { CtaButton },
  data() {
    return { icons };
  },
};
</script>

<style lang="scss" scoped>
// Scoped to .flow-phone-frame, same as StepBankOverlay.
.mortgage-report-help {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  pointer-events: none;
}

.overlay-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #202125;
  opacity: 0.89;
  pointer-events: auto;
}

.overlay-sheet {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 84%;
  background: #f9f7ed;
  border-radius: 36px 36px 0 0;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  overflow: hidden;

  @media (max-width: 500px) {
    height: 86%;
  }
}

.sheet-close {
  position: absolute;
  top: 18px;
  left: 24px;
  right: auto;
  width: 22px;
  height: 22px;
  padding: 0;
  background: none;
  border: 0;
  cursor: pointer;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.sheet-content {
  padding: 64px 28px 16px;
  overflow-y: auto;
  flex: 1;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.sheet-heading {
  font-family: 'SimplerProAlte', sans-serif;
  font-size: 32px;
  line-height: 36px;
  font-weight: 900;
  font-style: normal;
  font-synthesis: none;
  color: #205441;
  text-align: right;
  margin: 0 0 20px;

  @media (max-width: 500px) {
    font-size: 26px;
    line-height: 30px;
  }
}

.sheet-body {
  font-family: 'SimplerPro', sans-serif;
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  color: #205441;
  text-align: right;
  margin: 0 0 18px;

  strong {
    font-weight: 700;
  }
}

.tip-callout {
  background: #e8f4ba;
  border-radius: 8px;
  padding: 16px 18px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.tip-text {
  font-family: 'SimplerPro', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #205441;
  text-align: right;
  margin: 0;
  flex: 1;
}

.tip-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: block;
}

.sheet-cta-area {
  flex-shrink: 0;
  padding: 16px 28px 24px;
}

// Slide-up panel animation. Mirrors StepBankOverlay so both sheets behave
// the same — the parent <transition name="overlay-slide"> applies the
// `.overlay-slide-enter` / `.overlay-slide-leave-to` classes to the root
// element and we transition the backdrop opacity + sheet transform.
.overlay-slide-enter-active,
.overlay-slide-leave-active {
  .overlay-backdrop {
    transition: opacity 0.35s ease;
  }
  .overlay-sheet {
    transition: transform 0.45s cubic-bezier(0.16, 1, 0.3, 1);
  }
}

.overlay-slide-enter,
.overlay-slide-leave-to {
  .overlay-backdrop {
    opacity: 0;
  }
  .overlay-sheet {
    transform: translateY(100%);
  }
}
</style>
